import { render } from "./registrar-factura.vue?vue&type=template&id=f304ffe6&scoped=true"
import script from "./registrar-factura.vue?vue&type=script&lang=js"
export * from "./registrar-factura.vue?vue&type=script&lang=js"

import "./registrar-factura.vue?vue&type=style&index=0&id=f304ffe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f304ffe6"]])

export default __exports__